import { Injectable } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ConfigService, NoRestApiHelper } from '@services';

@Injectable({
  providedIn: 'root'
})
export class InternationalInvoiceTemplateApiService {

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private noRestApiHelper: NoRestApiHelper,
  ) {}

  remove(DocumentRefs: string[]): Observable<any> {
    const deleteObs: any = this.http.post(
      `${this.configService.get('apiUrl')}json/`,
      {
        system: this.configService.get('system'),
        modelName: 'InternationalTemplateGeneral',
        calledMethod: 'delete',
        methodProperties: {
          DocumentRefs,
        },
      },
    );

    return deleteObs.pipe(
      map((data) => this.noRestApiHelper.checkErrors({ data }))
    );
  }
}
